import { palette, shadeHex, tintHex } from '../ns-styles/tokens/index.js';

// Cytoscape and canvas can't read CSS custom properties, so the graph's colours are plain constants shared with the legend CSS.
const line = tintHex(palette['grey-dark'], 80);
const darkAmber = shadeHex(palette.amber, 50);

export const GRAPH_COLOURS = {
  canvas: palette.container,
  nodeFill: palette.container,
  pill: palette.background,
  label: palette.type,
  line,
  lineStrong: palette['grey-dark'],
  lateral: palette.teal,
  highlight: palette.purple,
  highlightSoft: tintHex(palette.purple, 70),
  aggregateFill: tintHex(palette.purple, 20),
  aggregateExpandedFill: tintHex(palette.purple, 10),
  locked: darkAmber,
  // unknown: the score couldn't be read, apart from unscored (nothing published), and never dashed, which means not connected
  risk: {
    high: palette.red,
    medium: darkAmber,
    low: shadeHex(palette.green, 40),
    unscored: line,
    unknown: palette.type,
  },
  activity: { active: palette.purple, inactive: line },
  people: { member: line, leadership: darkAmber, management: palette.teal, shareholder: tintHex(palette.purple, 70) },
  party: { invited: darkAmber, declined: palette.red },
  org: { primaryLine: palette['grey-dark'], dottedLine: palette.purple, you: palette.teal },
} as const;
